exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto+Condensed);", ""]);

// module
exports.push([module.id, "#app,body,html{font-family:Roboto,sans-serif}", ""]);

// exports
